import '../styles/ShowDashboard.css';
import './ShowDashboardContent.css';

import { Col }                          from 'antd';
import Row                              from 'components/App/Row';
import ShowDashboardOrganizerBox        from './ShowDashboardOrganizerBox';
import ShowDashboardShowInformationsBox from './ShowDashboardShowInformationsBox';
import { showDashboardStore }           from 'stores/index';
import DemandConfigListBox              from './DemandConfigListBox';

const ShowDashboardContent = ({
  synchronize,
  synchronized,
}: {
  synchronize: () => void;
  synchronized: boolean;
}) => {
  const { organizerModel } = showDashboardStore;

  return (
    <Row>
      <Col span={24}>
        <ShowDashboardShowInformationsBox
          synchronize={synchronize}
          synchronized={synchronized}
        />
      </Col>

      <Col span={24}>
        <DemandConfigListBox />
      </Col>

      <Col span={24}>
        <ShowDashboardOrganizerBox
          organizerModel={organizerModel}
        />
      </Col>
    </Row>
  );
};

export default ShowDashboardContent;
